import CardRoom from "./CardRoom";
import WidgetGuest from "./WidgetGuest";
import { layout as housekeeping } from "apps/HotelFrontdesk/reports/reportHouseKeeping";

const stateTags = {
  clean: "bg-sky-200 border-sky-400 text-sky-700",
  dirty: "bg-rose-200 border-rose-400 text-rose-800",
  not_authorized: "bg-lime-200 border-lime-500 text-lime-700",
  maintenance: "bg-neutral-700 border-neutral-900 text-neutral-100",
};

const occ_state = {
  departure: "bg-violet-200 border-violet-400 text-violet-700",
  vacancy: "bg-emerald-200 border-emerald-400 text-emerald-800",
  occupied: "bg-amber-200 border-amber-400 text-amber-700",
};

function getCheckinWidget({ record }) {
  return WidgetGuest("check_in", record);
}

function getCheckoutWidget({ record }) {
  console.log("getCheck Widget", record);
  return WidgetGuest("check_out", record);
}

function getBtnInvisible(btn, record) {
  if (btn === "clean" && record?.state === "maintenance") return true;
  return record?.state === btn;
}

function layout(props) {
  const ctxView = {
    model: "hotel.room",
    table_action: ["open"],
    form_action: ["edit"],
    card_action: ["open"],
    defaultView: "cards",
    // filters: getFilters,
    activeFilter: false,
    activeSearch: true,
    softDomain: ["active", "=", true],
    domain: [], // Options: null or valid domain
    orderBy: [["code", "ASC"]],
    selectable: null, // Options for table rows: null, multi, one
    title: { field: "rec_name" },
    Card: CardRoom,
    toolbar_table: {
      reports: [
        {
          name: "hotel.print_housekeeping.report",
          label: "housekeeping.description_report",
          description: "housekeeping.description_report",
          layout: housekeeping(props),
        },
      ],
    },
    tags: {
      state: stateTags,
      occ_state: occ_state,
    },
    fields: {
      name: {
        type: "char",
        readOnly: true,
      },
      notes: { type: "text"},
      type_: {
        type: "many2one",
        model: "hotel.room.type",
        readOnly: true,
      },
      cleaning_type: {
        type: "many2one",
        model: "hotel.room.cleaning_type",
        readOnly: true,
      },
      current_guests: {
        type: "integer",
        readOnly: true,
        // function: getCurrentGuests,
      },
      location: {
        type: "many2one",
        model: "hotel.location",
        readOnly: true,
      },
      housekeeping: {
        type: "many2one",
        model: "company.employee",
        readOnly: true,
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      last_check_in: {
        type: "datetime",
        readOnly: true,
      },
      last_check_out: {
        type: "datetime",
        readOnly: true,
      },
      last_clean: {
        type: "datetime",
        readOnly: true,
      },
      check_out_widget: {
        type: "custom",
        component: getCheckoutWidget,
        depends: ["check_out_today", "departure_today", "occupied_today"],
      },
      check_in_widget: {
        type: "custom",
        component: getCheckinWidget,
        depends: ["check_in_today", "arrival_today", "occupied_today"],
      },
      check_in_today: { type: "time" },
      check_out_today: { type: "time" },
      arrival_today: { type: "boolean" },
      departure_today: { type: "boolean" },
      occupied_today: { type: "boolean" },
      clean: {
        type: "button",
        button_method: "clean",
        invisible: getBtnInvisible,
        onSuccessMsg: "hotel.housekeeping.msg_now_room_is_clean",
        color: "blue",
      },
      not_authorized: {
        type: "button",
        button_method: "not_authorized",
        invisible: getBtnInvisible,
        onSuccessMsg: "hotel.housekeeping.msg_now_room_is_not_auth",
        color: "green",
      },
      maintenance: {
        type: "button",
        button_method: "maintenance",
        invisible: getBtnInvisible,
        onSuccessMsg: "hotel.housekeeping.msg_now_room_is_maintenance",
        color: "black",
      },
      dirty: {
        type: "button",
        button_method: "dirty",
        invisible: getBtnInvisible,
        onSuccessMsg: "hotel.housekeeping.msg_now_room_is_dirty",
        color: "rose",
        outline: true,
      },
    },
    list: [
      { name: "name", width: "15%" },
      { name: "state", width: "10%", widget: "circle" },
      { name: "cleaning_type", width: "15%" },
      { name: "clean", width: "25%" },
      { name: "not_authorized", width: "25%" },
      { name: "occupied_today", width: "25%" },
      { name: "type_", width: "25%" },
      { name: "location", width: "25%" },
    ],
    form: [
      { name: "name", colSpan: "col-span-2", style: "font-bold text-lg" },
      { name: "current_guests" },
      { name: "type_" },
      { name: "location" },
      { name: "check_out_widget" },
      { name: "check_in_widget" },
      { name: "cleaning_type" },
      { name: "state" },
      { name: "housekeeping" },
      { name: "last_clean" },
      {
        name: "buttons",
        type: "grid",
        elements: [
          { name: "clean" },
          { name: "not_authorized" },
          { name: "dirty" },
          { name: "maintenance" },
        ],
        colSpan: "col-span-2",
      },
      {
        name: "description",
        type: "grid",
        cols: "grid-cols-1",
        elements: [ { name: "notes" }],
      },
    ],

    cards: [
      { name: "name" },
      { name: "state" },
      { name: "type_" },
      { name: "cleaning_type" },
      { name: "last_clean" },
      { name: "housekeeping" },
      { name: "clean" },
      { name: "check_out_today" },
      { name: "notes" },
    ],
  };

  return ctxView;
}

export { layout };
